import { Box, IconButton, Tooltip } from "@mui/material";
import { Download, PictureAsPdf, Description } from "@mui/icons-material";

export const FileActionCard = ({ url, t, onView, onDownload }: any) => {
    const isDoc = url.toLowerCase().includes('.pdf') || url.toLowerCase().includes('.txt');

    const onThumbnailClick = () => {
        if (isDoc) {
            window.open(url, '_blank', 'noopener,noreferrer');
        } else {
            onView(url);
        }
    };

    return (
        <Box position="relative" sx={{ width: 80, height: 80, borderRadius: 2, overflow: 'hidden', border: '1px solid #eee' }}>
            <Box
                onClick={onThumbnailClick}
                sx={{
                    width: '100%',
                    height: '100%',
                    cursor: isDoc ? 'pointer' : 'zoom-in',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: '#f5f5f5'
                }}
            >
                {isDoc ? (
                    url.toLowerCase().includes('.pdf') ? <PictureAsPdf color="error" /> : <Description color="action" />
                ) : (
                    <Box component="img" src={url} sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                )}
            </Box>

            <Tooltip title={t('download')}>
                <IconButton
                    size="small"
                    onClick={(e) => {
                        e.stopPropagation();
                        onDownload(url);
                    }}
                    sx={{
                        position: 'absolute',
                        top: 2,
                        right: 2,
                        bgcolor: 'rgba(255,255,255,0.8)',
                        '&:hover': { bgcolor: '#fff' },
                        p: 0.5
                    }}
                >
                    <Download sx={{ fontSize: 14 }} />
                </IconButton>
            </Tooltip>
        </Box>
    );
};